import Anchor from '@oneflare/flarekit/lib/components/Anchor';
import Button from '@oneflare/flarekit/lib/components/Button';
import H1 from '@oneflare/flarekit/lib/components/H1';
import Paragraph from '@oneflare/flarekit/lib/components/Paragraph';
import media from '@oneflare/flarekit/lib/libs/media';
import NextImage from 'next/image';
import { styled } from 'styled-components';

export const HeroStyled = styled.section`
  align-items: center;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  padding: 32px 20px 40px;
  position: relative;
  z-index: ${({ theme }) => theme.zIndex[0]};
  ${({ theme }) => `background: ${theme.color.tin}`};
  ${({ $kind }) => $kind === 'light' && 'padding: 57px 32px 87px;'};
  ${media.mdUp`
    margin: 0px 0px 80px;
    padding: 32px 32px 48px;
    min-height: 430px;
  `}
`;

export const HeroImageStyled = styled(NextImage)`
  z-index: -1;
  ${media.mdDown`
    display: none !important;
  `}
`;

// required to centre intro component to align with cards on the bottom of the page
export const HeroIntroWrapperStyled = styled.div`
  width: 100%;
  padding: 0;

  ${media.lgUp`
    width: 1200px;
    padding-inline: 40px;
  `}
`;


export const HeroIntroStyled = styled.section`
  padding: 32px 20px;
  background: ${({ theme }) => theme.color.tin};
  border-radius: 8px;
  box-shadow: none;

  ${media.lgUp`
    box-shadow: 0 0 8px 0 rgba(38, 49, 51, 10%);
    padding: 40px 32px;
    position: unset;
    background: ${({ theme }) => theme.color.white};
    width: 550px;
  `}
`;

export const HeroTitleStyled = styled(H1)`
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 28px;
  line-height: 1.5;
  margin: 0 0 16px;
`;

export const HeroIntroTextStyled = styled(Paragraph)`
  color: ${({ theme }) => theme.color.gunMetal};
  font-size: 18px;
  line-height: 1.5;
  margin: 0 0 32px;
`;

export const GetFreeQuotesButtonStyled = styled(Button)`
  width: 100%;

  ${media.smUp`
    width: auto;
  `}
`;

export const HeroParentCategoryStyled = styled(Anchor)`
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.font.secondaryBold};
  color: ${({ theme }) => theme.color.silver};
  font-size: 12px;
  line-height: 1.5;
  margin: 0 0 8px;
  display: inline-block;

  &:hover {
    text-decoration: underline;
  }
`;
